<template>
  <Loading v-if="!fullyLoaded" />
  <ChemicalForm
    v-else
    :chemicalTypes="chemicalTypes"
    :chemicalManufacturers="chemicalManufacturers"
    :resource="resource"
    :submit="submit"
    :destroy="destroy"
    :cancel="cancel"
  />
</template>

<script>
import EditView from '@/mixins/editView';
import ResourceService from '@/services/resources/chemicals_service';
import ChemicalTypeService from '@/services/resources/chemical_types_service';
import ChemicalManufacturerService from '@/services/resources/chemical_manufacturers_service';

export default {
  mixins: [EditView],
  components: {
    ChemicalForm: () => import('@/components/forms/ChemicalForm.vue'),
  },
  data() {
    return {
      resourceParams: {
        include: 'chemical-manufacturer,chemical-type',
      },
      urlFragment: 'chemicals',
      resourceService: ResourceService,
    };
  },
  asyncComputed: {
    chemicalTypes: {
      get() {
        return ChemicalTypeService.index().then((types) => {
          return types.data;
        });
      },
      default: [],
      shouldUpdate() {
        return this.asyncComputedShouldUpdate();
      },
    },
    chemicalManufacturers: {
      get() {
        return ChemicalManufacturerService.index().then((manufacturers) => {
          return manufacturers.data;
        });
      },
      default: [],
      shouldUpdate() {
        return this.asyncComputedShouldUpdate();
      },
    },
  },
};
</script>
